import Highcharts from "highcharts";
import { useInternationalFormatters } from "../helpers/useInternationalFormatters";
import { useTranslation } from "react-i18next";

const chartElementsColour = "#495057";

export function useHighchartsTheme() {
  const { t } = useTranslation();
  const { localDateStrings } = useInternationalFormatters();

  const theme: Highcharts.Options = {
    lang: {
      months: localDateStrings.monthNames,
      shortMonths: localDateStrings.monthNamesShort,
      weekdays: [
        t("common.sundayShort"),
        t("common.mondayShort"),
        t("common.tuesdayShort"),
        t("common.wednesdayShort"),
        t("common.thursdayShort"),
        t("common.fridayShort"),
        t("common.saturdayShort"),
      ],
      noData: t("common.chartNoData"),
      resetZoom: t("common.resetZoom"),
      downloadCSV: t("common.downloadFile", { fileType: `$t(fileTypes.csv)` }),
      downloadPNG: t("common.downloadFile", { fileType: `$t(fileTypes.png)` }),
      viewFullscreen: t("common.viewFullscreen"),
    },
    colors: ["#058DC7", "#50B432", "#ED561B", "#DDDF00", "#24CBE5", "#64E572", "#FF9655", "#FFF263", "#6AF9C4"],
    chart: {
      zoomType: "xy",
      backgroundColor: "none",
      borderWidth: 0,

      style: {
        "font-family": "Roboto",
        color: chartElementsColour,
      },
    },
    title: {
      style: {
        color: chartElementsColour,
        fontSize: "14px",
      },
    },
    subtitle: {
      style: {
        color: chartElementsColour,
      },
    },
    legend: {
      itemStyle: {
        font: "9pt Trebuchet MS, Verdana, sans-serif",
        color: chartElementsColour,
      },
      itemHoverStyle: {
        color: chartElementsColour,
      },
    },
    xAxis: {
      labels: {
        style: {
          color: chartElementsColour,
        },
      },
      showLastLabel: true,
      maxPadding: 0.05,
      lineWidth: 1,
      lineColor: chartElementsColour,
    },
    yAxis: {
      labels: {
        style: {
          color: chartElementsColour,
        },
      },
      gridLineWidth: 0,
      lineWidth: 1,
      lineColor: chartElementsColour,
    },
    navigation: {
      buttonOptions: {
        theme: {
          fill: "none",
          stroke: "none",
        },
      },
    },
  };

  return theme;
}
